import { render, staticRenderFns } from "./headView.vue?vue&type=template&id=b32219d4&scoped=true"
import script from "./headView.vue?vue&type=script&lang=js"
export * from "./headView.vue?vue&type=script&lang=js"
import style0 from "./headView.vue?vue&type=style&index=0&id=b32219d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32219d4",
  null
  
)

export default component.exports